// extracted by mini-css-extract-plugin
export var go_back_link = "styles-module--go_back_link--6ee5b";
export var go_back_link_wrapper = "styles-module--go_back_link_wrapper--ef3f0";